var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"detail-d1"},[_c('div',{staticClass:"detail-lbl"},[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),_c('div',{staticClass:"detail-lbl-gry"},[_vm._v(_vm._s(_vm.value))])])
}
var staticRenderFns = []

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/components/common/ReadOnlyField.vue